export const homeProductCarouselStyles = {
  root: 'w-full py-2',
} as const;
